













































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { Sheet } from "../../modules/student/DigitalPaperList"

export interface Data {
  sheets: Sheet[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheets: [],
      errors: [],
    });

    /******************************
     * 回答画面へ遷移
     ******************************/

    const toAnswerInput = (sheet_id: number) => {
      if(context.root.$store.getters.isAdmin){
        context.root.$router.push(`/teacher_site/answer_input/${sheet_id}`).catch(err => {});
      }else{
        context.root.$router.push(`/${context.root.$store.state.currentUser.school_id}/student_site/answer_input/${sheet_id}`).catch(err => {});
      }
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/student/digital_paper_list?student_no_character=${context.root.$store.state.student_no_character}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      toAnswerInput
    }
  }
});
